// CDC card dashboard search API client. Thin ApiClient subclass calling the
// Phase 5 endpoint, contact-bound contract (contact_id + field), no free-text
// parameter. Origem: ADR 0008.
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class CardDashboardSearchAPI extends ApiClient {
  constructor() {
    super('custom/card_dashboard', { accountScoped: true });
  }

  search(contactId, field) {
    return axios.get(`${this.url}/search`, {
      params: { contact_id: contactId, field },
    });
  }
}

export default new CardDashboardSearchAPI();
